// api/configApi.ts
import { baseApi } from "./BaseApi";
import { Config } from "../types/configTypes";

const configApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getConfig: builder.query<Config, void>({
      query: () => `/config`,
    }),
  }),
});

export const {
  useGetConfigQuery
} = configApi;

export default configApi;